import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '@app/material.module';
import { VideoPlayerModuleComponent } from './video-player-module.component';
import { SharedModule } from '@app/@shared';

@NgModule({
  imports: [CommonModule, TranslateModule, MaterialModule, SharedModule],
  declarations: [VideoPlayerModuleComponent],
  exports: [VideoPlayerModuleComponent],
})
export class VideoPlayerModuleModule {}
